"use client";

import * as React from "react";

import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from "../../../components/ui/sheet";
import { Settings } from "lucide-react";
import { Button } from "../../../components/ui/button";
import { useTranslation } from "../../../contexts/I18nProvider";
import { useLanguageBooks } from "../_hooks/useLanguageBooks";
import LanguageCheckboxes from "./form-items/language-checkboxes";
import LanguageSearchInput from "./form-items/language-search-input";
import QuickFilterPills from "./quick-filter-pills";
import ActiveLanguages from "./active-languages";
import MiscallenousBar from "./miscallenous-bar";
import { useSelector } from "react-redux";
import {
  selectFilteredLanguages,
  selectLanguagesData,
  selectPurchasedLanguages,
} from "../../../redux/selectors/languageSelectors";
import { selectQuickFilter } from "../../../redux/selectors/filterSelectors";

export function MobileFilterToolbar() {
  const { t } = useTranslation();
  useLanguageBooks(); // Fetch languages and books
  const languages = useSelector(selectLanguagesData);
  const filteredLanguages = useSelector(selectFilteredLanguages);
  const purchasedLanguages = useSelector(selectPurchasedLanguages);
  const quickFilter = useSelector(selectQuickFilter);

  const languageHeader =
    quickFilter === "audio"
      ? t('polyglot.languagesWithAudio')
      : quickFilter === "purchased"
        ? t('polyglot.purchasedLanguages')
        : quickFilter === "recent"
          ? t('polyglot.recentLanguages')
          : t('polyglot.africanLanguages');

  return (
    <Sheet>
      <SheetTrigger asChild className="lg:hidden mt-12">
        <Button className="rounded-r-sm rounded-l-none absolute left-0 top-20 z-50 bg-primary hover:bg-primary-dark text-white font-semibold">
          <Settings className="w-4 h-4" /> {t('polyglot.languages')}
        </Button>
      </SheetTrigger>
      <SheetContent
        side={"left"}
        className="bg-gradient-to-br from-white via-[hsl(var(--gradient))]/10 to-white border-r border-border/40"
      >
        <SheetHeader>
          <SheetTitle className="text-lg font-bold text-primary">{t('polyglot.filters')}</SheetTitle>
          <SheetDescription>
            {t('polyglot.filtersDescription')}
          </SheetDescription>
        </SheetHeader>
        <div className="w-full mt-14 rounded-2xl space-y-4">
          <div className="space-y-4">
            <LanguageSearchInput />

            <QuickFilterPills />

            <ActiveLanguages />

            <div className="flex items-center justify-between text-xs uppercase tracking-wide text-muted-foreground">
              <span>{languageHeader}</span>
              <span>
                (
                {quickFilter === "purchased"
                  ? purchasedLanguages.length
                  : filteredLanguages.length || languages.length}
                )
              </span>
            </div>

            <LanguageCheckboxes />

            <MiscallenousBar />
          </div>
        </div>
      </SheetContent>
    </Sheet>
  );
}
